/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
export enum BundleSettlementsDetailColumnEnum {
    QUANTITY = 'QUANTITY',
    MATERIALS_UNIT_NET_COST = 'MATERIALS_UNIT_NET_COST',
    MATERIALS_TOTAL_NET_COST = 'MATERIALS_TOTAL_NET_COST',
    TAX_RATE = 'TAX_RATE',
    MATERIALS_TOTAL_GROSS_COST = 'MATERIALS_TOTAL_GROSS_COST',
    TE_AMOUNT = 'TE_AMOUNT',
    TE_UNIT_COST = 'TE_UNIT_COST',
    TE_ADDITIONAL_COSTS = 'TE_ADDITIONAL_COSTS',
    TE_TOTAL_COST = 'TE_TOTAL_COST',
    BLUE_FAPIAO_NUMBER = 'BLUE_FAPIAO_NUMBER',
    DELIVERY_NUMBER = 'DELIVERY_NUMBER',
    SALES_DOCUMENT = 'SALES_DOCUMENT',
    COMMENTS = 'COMMENTS'
}
